function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3282"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3268"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2973",
  d: "M311.615 24.574c-18.7-31.672-272.028-31.193-287.117 0-32.729 67.662-29.9 85.606 0 132.353 35.5-35.386 251.621-32.27 287.117 0 20.896-26.703 32.815-76.767 0-132.353z",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3269"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 652",
  strokeWidth: 2,
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none",
  d: "M134.314 37.591h71.89v41.612h-71.89z"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3270"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2974",
  d: "M236.055 17.304H104.464l5.323 11.142h120.944z",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3274"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3271"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 25",
  cx: 46.246,
  cy: 46.246,
  r: 46.246,
  strokeWidth: 2,
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none",
  transform: "translate(217.59 33.978)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3272"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 26",
  cx: 7.114,
  cy: 7.114,
  r: 7.114,
  strokeWidth: 2,
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none",
  transform: "translate(256.721 73.109)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3273"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2975",
  stroke: "#b7b7b7",
  d: "M232.503 98.055l22.535-14.154.883 1.515z",
  fill: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  fillRule: "evenodd"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3278"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3275"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 27",
  cx: 46.246,
  cy: 46.246,
  r: 46.246,
  strokeWidth: 2,
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none",
  transform: "translate(31.88 33.978)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3276"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 28",
  cx: 7.114,
  cy: 7.114,
  r: 7.114,
  strokeWidth: 2,
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none",
  transform: "translate(71.011 73.109)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3277"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2976",
  stroke: "#b7b7b7",
  d: "M46.792 98.055l22.532-14.153.883 1.515z",
  fill: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  fillRule: "evenodd"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3280"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3279",
  fill: "#b7b7b7"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2977",
  d: "M142.532 73.95a3.586 3.586 0 01.142-1.117 1.387 1.387 0 01.425-.652 1.082 1.082 0 01.708-.23 1.154 1.154 0 01.552.127 1.056 1.056 0 01.393.366 1.955 1.955 0 01.243.581 3.868 3.868 0 01.088.925 3.583 3.583 0 01-.142 1.111 1.385 1.385 0 01-.423.654 1.087 1.087 0 01-.711.232 1.073 1.073 0 01-.888-.406 2.577 2.577 0 01-.387-1.591zm.493 0a2.454 2.454 0 00.225 1.282.644.644 0 001.113 0 3.75 3.75 0 000-2.564.669.669 0 00-.561-.317.616.616 0 00-.528.28 2.475 2.475 0 00-.249 1.319z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2978",
  d: "M147.111 75.878v-.937h-1.7v-.44l1.786-2.534h.392v2.534h.528v.44h-.528v.937zm0-1.377v-1.763l-1.225 1.763z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2979",
  d: "M150.15 75.878v-.937h-1.7v-.44l1.785-2.534h.393v2.534h.528v.44h-.528v.937zm0-1.377v-1.763l-1.225 1.763z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2980",
  d: "M153.189 75.878v-.937h-1.7v-.44l1.785-2.534h.393v2.534h.528v.44h-.528v.937zm0-1.377v-1.763l-1.225 1.763z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2981",
  d: "M154.689 74.854l.5-.042a.9.9 0 00.26.553.7.7 0 00.492.186.769.769 0 00.587-.261.988.988 0 00.24-.694.889.889 0 00-.231-.648.8.8 0 00-.6-.238.838.838 0 00-.419.105.82.82 0 00-.293.274l-.451-.059.379-2.009h1.945v.459h-1.565l-.211 1.051a1.274 1.274 0 01.739-.245 1.171 1.171 0 01.865.355 1.24 1.24 0 01.353.912 1.428 1.428 0 01-.31.918 1.241 1.241 0 01-1.028.476 1.266 1.266 0 01-.871-.3 1.167 1.167 0 01-.381-.793z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2982",
  d: "M157.997 75.879v-.547h.547v.547z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2983",
  d: "M159.246 73.95a3.608 3.608 0 01.142-1.117 1.392 1.392 0 01.425-.652 1.083 1.083 0 01.709-.23 1.156 1.156 0 01.552.127 1.062 1.062 0 01.393.366 1.955 1.955 0 01.242.581 3.861 3.861 0 01.089.925 3.581 3.581 0 01-.142 1.111 1.374 1.374 0 01-.423.654 1.085 1.085 0 01-.711.232 1.074 1.074 0 01-.889-.406 2.577 2.577 0 01-.387-1.591zm.493 0a2.453 2.453 0 00.226 1.282.644.644 0 001.113 0 3.762 3.762 0 000-2.564.67.67 0 00-.562-.317.616.616 0 00-.528.28 2.482 2.482 0 00-.249 1.319z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2984",
  d: "M163.937 75.878v-2.834h.43v.4a1.009 1.009 0 01.355-.335 1 1 0 01.5-.127.935.935 0 01.517.13.7.7 0 01.284.365 1.018 1.018 0 01.875-.5.863.863 0 01.649.233 1 1 0 01.226.719v1.946h-.478V74.09a1.338 1.338 0 00-.046-.415.4.4 0 00-.169-.2.532.532 0 00-.289-.077.67.67 0 00-.5.2.875.875 0 00-.2.636v1.647h-.481V74.04a.815.815 0 00-.117-.481.445.445 0 00-.384-.159.694.694 0 00-.375.107.6.6 0 00-.25.312 1.761 1.761 0 00-.077.593v1.47z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2985",
  d: "M168.492 72.519v-.552h.48v.552zm0 3.359v-2.834h.48v2.834z"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3281"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2986",
  d: "M208.966 86.619h-74.219l9.7 7.156h54.82z",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})));

function SvgOdometerGraphic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310.01,
    height: 157.928,
    viewBox: "0 0 333 158"
  }, props), _ref);
}

export default SvgOdometerGraphic;